import React from "react";
import cn from "classnames";
import PostcardHero from "../../components/PostcardHero";
import LivePulse from "../../components/LivePulse";
import styles from "../Stays/Main/Main.module.sass";
import pageStyles from "./InfoPage.module.sass";

const InfoPage = ({ title, body, content, belowHeader, below, divider, belowTitleCenter, belowContent, disableStamps, tallOverride, customMinHeight, showInlineLivePulse }) => {
  const isOurStory = title === "Our Story";
  const isWhatIs = title === "What is Postaway";
  const tallValue = (typeof tallOverride !== 'undefined') ? tallOverride : true;
  const heroProps = below
    ? { hideGuides: true, hideTagline: true, showDividerOnly: Boolean(divider), belowHeader, belowTitle: title, belowTitleCenter, belowContent: below, disableStamps, tall: tallValue }
    : belowContent
    ? { hideGuides: !divider, hideTagline: true, showDividerOnly: Boolean(divider), belowContent, disableStamps, tall: tallValue }
    : {
        hideGuides: true,
        hideTagline: true,
        ...(isOurStory ? {} : { centerTitle: title }),
        ...(isOurStory ? { centerSubTitle: "Our Story" } : {}),
        centerBody: body,
        centerContent: content,
        centerImageSrc: isOurStory ? undefined : undefined,
        centerImageAlt: isOurStory ? undefined : undefined,
        pushDown: isOurStory,
        pushDownLight: isWhatIs,
        disableStamps,
        tall: tallValue,
      };

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={cn(styles.preview, pageStyles.previewAuto)}>
          <div className={cn(styles.wrap, pageStyles.innerWrap)}>
            <PostcardHero
              brandHeader
              {...heroProps}
              brandHeaderAddon={showInlineLivePulse ? <LivePulse inline /> : null}
              customMinHeight={typeof customMinHeight !== 'undefined' ? customMinHeight : (tallValue ? undefined : 1040)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPage;


